var _defs, _rect, _polygon, _polygon2, _rect2, _polygon3, _polygon4, _rect3, _polygon5, _polygon6, _rect4, _polygon7, _polygon8, _path, _path2, _ellipse, _rect5, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 790 320",
    width: "790pt",
    height: "320pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_pp2m7wJ9VJFHtySlmYo6f1cO82kTXkF0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 790,
    height: 320
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_pp2m7wJ9VJFHtySlmYo6f1cO82kTXkF0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_0",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientTransform: "matrix(17,0,0,143,58,143.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0.88,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46.95652173913044%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(100,152,242)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 143.59,
    width: 17,
    height: 143,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "url(#_lgradient_0)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "66.5,103.59,75,143.59,58,143.59",
    fill: "rgb(247,186,95)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "66.5,103.59,69.241,116.59,63.759,116.59",
    fill: "rgb(74,134,232)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_1",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientTransform: "matrix(17,0,0,117.234,92.337,15.569)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46.95652173913044%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(100,152,242)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.337,
    y: 15.569,
    width: 17,
    height: 117.234,
    transform: "matrix(0.5,0.866,-0.866,0.5,114.666,-50.234)",
    fill: "url(#_lgradient_1)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "180,28.482,155.851,52.239,147.351,37.517",
    fill: "rgb(247,186,95)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 4
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "180,28.482,172.141,36.184,169.4,31.437",
    fill: "rgb(74,134,232)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientTransform: "matrix(17,0,0,143,285,143.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46.95652173913044%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(100,152,242)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 143.59,
    width: 17,
    height: 143,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "url(#_lgradient_2)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.5,103.59,302,143.59,285,143.59",
    fill: "rgb(247,186,95)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 5
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.5,103.59,296.241,116.59,290.759,116.59",
    fill: "rgb(74,134,232)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientTransform: "matrix(17,0,0,117.234,250.663,15.569)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46.95652173913044%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(100,152,242)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 250.663,
    y: 15.569,
    width: 17,
    height: 117.234,
    transform: "matrix(0.5,-0.866,0.866,0.5,65.334,261.535)",
    fill: "url(#_lgradient_3)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 2
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "180,28.482,212.649,37.517,204.149,52.239",
    fill: "rgb(247,186,95)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 4
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "180,28.482,190.6,31.437,187.859,36.184",
    fill: "rgb(74,134,232)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 5
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_4",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientTransform: "matrix(47,0,0,165.559,166,121.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(100,152,242)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.3913043478261%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(74,134,232)"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 213 121.59 L 166 134.59 L 166 270.59 L 213 287.149",
    fill: "url(#_lgradient_4)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 147 286.535 L 147 121.59 L 213 121.59 L 213 286.535",
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 3,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    vectorEffect: "non-scaling-stroke",
    cx: 172.49999999999983,
    cy: 209.8678520034901,
    rx: 2.500000000000057,
    ry: 2.7490724739676295,
    fill: "rgb(0,0,0)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 767,
    height: 300,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "none",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,1,365,144.866)",
    style: {
      fontFamily: "'Pangolin'",
      fontWeight: 400,
      fontSize: 50,
      fontStyle: "normal",
      fill: "#000000",
      stroke: "none"
    }
  }, "\n                In The Schoolroom\n            "), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,1,395.625,212)",
    style: {
      fontFamily: "'Pangolin'",
      fontWeight: 400,
      fontSize: 32,
      fontStyle: "normal",
      fill: "#000000",
      stroke: "none"
    }
  }, "\n                'Opening Doors Together'\n            ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 348,
    y1: 19,
    x2: 348,
    y2: 297,
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 2,
    stroke: "rgb(0,0,0)",
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    strokeMiterlimit: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithText);
export default __webpack_public_path__ + "static/media/logo-with-text.598fabc0d26b52efd2f2980b58deef91.svg";
export { ForwardRef as ReactComponent };